/*
 * @Descripttion:
 * @Author: zhangxu
 * @Date: 2025-01-07 16:26:43
 * @LastEditors: zhangxu
 * @LastEditTime: 2025-01-10 15:05:13
 */
import request from '@/utils/request'
import host from '@/api/base/host'

// 学习日历
const calendar = host.path('loca:xhl', { module: 'calendar', dev: 'v1/mydesk/learn/calendar' })

//学习报告
const daily = host.path('loca:xhl', { module: 'calendar', dev: 'v1/user/learn' })
export default {
  overview(data) {
    return request({
      url: calendar('overview'),
      method: 'post',
      data
    })
  },
  rangeview(data) {
    return request({
      url: calendar('rangeview'),
      method: 'post',
      data
    })
  },
  shareInfo(data) {
    return request({
      url: calendar('share'),
      method: 'post',
      data
    })
  },
  getdayReport(data) {
    return request({
      url: daily('report/day'),
      method: 'post',
      data
    })
  },
  getweekReport(data) {
    return request({
      url: daily('report/month'),
      method: 'post',
      data
    })
  }
}
